<div class="collapsible-card" [class.collapsed]="isCollapsed">
  <div class="card-header" [class.fixed-open]="isFixedOpen" (click)="onHeaderClick()">
    <h3 class="card-title">{{ title }}</h3>
    <div class="header-actions">
      <!-- <button class="edit-button" *ngIf="showEditButton && !isPasswordCard && !isEditing && !isCollapsed" (click)="onEditClick($event)">
        <span>Edit </span>
        <img src="assets/images/edit-icon.svg" alt="Edit" class="edit-icon" />
        <img src="assets/images/chevron-up.png" style="width:16px;height:16px;" alt="Edit" class="edit-icon" />
      </button> -->
      <!-- Password card specific button -->
      <!-- <button class="btn btn-outlined btn-small" *ngIf="isPasswordCard && !isEditing " (click)="onEditClickpassword($event)">
        Change Password
      </button> -->
      <!-- Regular collapse button for non-password cards -->
      <button class="collapse-button" *ngIf="!isPasswordCard && !(showEditButton && !isEditing && !isCollapsed) && !isFixedOpen">
        <img
          [src]="
            isCollapsed
              ? 'assets/images/chevron-down.png'
              : 'assets/images/chevron-up.png'
          "
          alt="Collapse"
          class="collapse-icon"
        />
      </button>
    </div>
  </div>
  <div class="card-content" *ngIf="!isCollapsed">
    <ng-content></ng-content>
  </div>
</div>
